/**
 * ============================================
 * Demo Products Data
 * ============================================
 * Fallback data when API is unavailable
 */

export const demoProducts = [
    {
        _id: '1',
        name: 'Voilage Élégance Blanc',
        description: 'Voilage léger et transparent, parfait pour filtrer la lumière naturelle tout en préservant votre intimité. Tissu de haute qualité avec finition raffinée.',
        category: 'Voilage',
        material: 'Polyester 100%',
        width: 2.8,
        mainImage: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?w=600',
        totalStock: 105,
        variants: [
            { _id: 'v1', name: 'Blanc Pur', color: '#FFFFFF', colorName: 'Blanc', stockQuantity: 45 },
            { _id: 'v2', name: 'Ivoire', color: '#FFFFF0', colorName: 'Ivoire', stockQuantity: 32 },
            { _id: 'v3', name: 'Crème', color: '#FFFDD0', colorName: 'Crème', stockQuantity: 28 }
        ],
        isFeatured: true
    },
    {
        _id: '2',
        name: 'Rideau Occultant Premium',
        description: 'Rideau occultant haute performance bloquant 99% de la lumière. Isolation thermique et phonique pour un confort optimal.',
        category: 'Occultant',
        material: 'Polyester occultant triple couche',
        width: 1.5,
        mainImage: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=600',
        totalStock: 185,
        variants: [
            { _id: 'v4', name: 'Noir Intense', color: '#1A1A1A', colorName: 'Noir', stockQuantity: 67 },
            { _id: 'v5', name: 'Gris Anthracite', color: '#383838', colorName: 'Anthracite', stockQuantity: 54 },
            { _id: 'v6', name: 'Bleu Nuit', color: '#191970', colorName: 'Bleu Nuit', stockQuantity: 41 },
            { _id: 'v7', name: 'Bordeaux', color: '#722F37', colorName: 'Bordeaux', stockQuantity: 23 }
        ],
        isFeatured: true
    },
    {
        _id: '3',
        name: 'Lin Naturel Scandinave',
        description: 'Rideau en lin naturel au style scandinave épuré. Texture authentique pour une ambiance chaleureuse et contemporaine.',
        category: 'Lin',
        material: 'Lin 80%, Coton 20%',
        width: 1.4,
        mainImage: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600',
        totalStock: 188,
        variants: [
            { _id: 'v8', name: 'Naturel', color: '#C4B896', colorName: 'Naturel', stockQuantity: 89 },
            { _id: 'v9', name: 'Gris Perle', color: '#C9C9C9', colorName: 'Gris Perle', stockQuantity: 56 },
            { _id: 'v10', name: 'Beige Sahara', color: '#D2B48C', colorName: 'Beige', stockQuantity: 43 }
        ],
        isFeatured: true
    },
    {
        _id: '4',
        name: 'Velours Royal Collection',
        description: 'Rideau en velours luxueux avec reflets soyeux. Collection prestigieuse pour intérieurs raffinés et espaces d\'exception.',
        category: 'Velours',
        material: 'Velours de coton 100%',
        width: 1.4,
        mainImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600',
        totalStock: 85,
        variants: [
            { _id: 'v11', name: 'Emeraude', color: '#50C878', colorName: 'Émeraude', stockQuantity: 18 },
            { _id: 'v12', name: 'Rubis', color: '#9B111E', colorName: 'Rubis', stockQuantity: 24 },
            { _id: 'v13', name: 'Saphir', color: '#0F52BA', colorName: 'Saphir', stockQuantity: 31 },
            { _id: 'v14', name: 'Or Antique', color: '#CFB53B', colorName: 'Or', stockQuantity: 12 }
        ],
        isFeatured: false
    },
    {
        _id: '5',
        name: 'Semi-Occultant Cosy',
        description: 'Rideau semi-occultant offrant le parfait équilibre entre lumière tamisée et intimité. Idéal pour salon et salle à manger.',
        category: 'Semi-Occultant',
        material: 'Polyester tissé',
        width: 1.5,
        mainImage: 'https://images.unsplash.com/photo-1540932239986-30128078f3c5?w=600',
        totalStock: 175,
        variants: [
            { _id: 'v15', name: 'Taupe', color: '#483C32', colorName: 'Taupe', stockQuantity: 72 },
            { _id: 'v16', name: 'Gris Clair', color: '#D3D3D3', colorName: 'Gris Clair', stockQuantity: 65 },
            { _id: 'v17', name: 'Chocolat', color: '#7B3F00', colorName: 'Chocolat', stockQuantity: 38 }
        ],
        isFeatured: false
    },
    {
        _id: '6',
        name: 'Thermique Performance+',
        description: 'Rideau thermique haute technologie avec doublure isolante. Économies d\'énergie garanties, été comme hiver.',
        category: 'Thermique',
        material: 'Polyester thermique multi-couches',
        width: 1.4,
        mainImage: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=600',
        totalStock: 215,
        variants: [
            { _id: 'v18', name: 'Blanc Polaire', color: '#F8F8FF', colorName: 'Blanc Polaire', stockQuantity: 92 },
            { _id: 'v19', name: 'Gris Glacier', color: '#778899', colorName: 'Gris Glacier', stockQuantity: 78 },
            { _id: 'v20', name: 'Argent', color: '#C0C0C0', colorName: 'Argent', stockQuantity: 45 }
        ],
        isFeatured: false
    },
    {
        _id: '7',
        name: 'Décoratif Bohème',
        description: 'Rideau décoratif avec motifs bohèmes tissés. Apporte caractère et personnalité à votre intérieur.',
        category: 'Décoratif',
        material: 'Coton tissé main',
        width: 1.3,
        mainImage: 'https://images.unsplash.com/photo-1618220179428-22790b461013?w=600',
        totalStock: 104,
        variants: [
            { _id: 'v21', name: 'Terracotta', color: '#E2725B', colorName: 'Terracotta', stockQuantity: 34 },
            { _id: 'v22', name: 'Moutarde', color: '#FFDB58', colorName: 'Moutarde', stockQuantity: 29 },
            { _id: 'v23', name: 'Olive', color: '#808000', colorName: 'Olive', stockQuantity: 41 }
        ],
        isFeatured: true
    },
    {
        _id: '8',
        name: 'Voilage Brodé Floral',
        description: 'Voilage délicat avec broderies florales. Romantique et intemporel pour une décoration classique chic.',
        category: 'Voilage',
        material: 'Organza brodé',
        width: 2.9,
        mainImage: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=600',
        totalStock: 98,
        variants: [
            { _id: 'v24', name: 'Blanc Floral', color: '#FFFAF0', colorName: 'Blanc Floral', stockQuantity: 56 },
            { _id: 'v25', name: 'Rose Poudré', color: '#E8CCD7', colorName: 'Rose Poudré', stockQuantity: 42 }
        ],
        isFeatured: false
    }
];

export const demoCategories = [
    { name: 'Voilage', count: 2 },
    { name: 'Occultant', count: 1 },
    { name: 'Lin', count: 1 },
    { name: 'Velours', count: 1 },
    { name: 'Semi-Occultant', count: 1 },
    { name: 'Thermique', count: 1 },
    { name: 'Décoratif', count: 1 }
];

export default demoProducts;
